import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { WalletInfo } from "../../../models/customer.model";
interface Props {
  wallet: WalletInfo;
  handleDetail: Function;
}

const CustomerLoanCard = ({ wallet, handleDetail }: Props) => {
  return (
    <Grid
      container
      sx={{ justifyContent: "start", alignItems: "center" }}
      spacing={2}
      columns={14}
    >
      <Grid
        item
        xs={14}
        sm={4}
        md={4}
        lg={3}
        xl={2}
        width={"100%"}
        height={"100%"}
      >
        <Box
          className="carousel-cards"
          sx={{
            width: "130px",
            height: "75px",
            borderRadius: "5px",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
            position: "relative",
          }}
          style={{
            background: `linear-gradient(160deg,rgba(255,255,255,.85), ${wallet?.colorCode})`,
          }}
        ></Box>
      </Grid>
      <Grid item xs={14} sm={10} md={10} lg={11} xl={12}>
        <Grid
          container
          flexDirection={"column"}
          gap={"15px"}
          justifyContent={"center"}
          alignItems={"start"}
          width={"100%"}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#1D4A87",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              {wallet?.title}
            </Typography>
            <Typography
              sx={{ fontSize: ".9rem", color: "#1D4A87", cursor: "pointer" }}
              onClick={() => handleDetail(wallet?.id)}
            >
              <HistoryOutlinedIcon
                sx={{ fontSize: "22px", marginLeft: "7px" }}
              />
              تراکنش های کیف
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              موجودی کیف:{" "}
              <span style={{ fontWeight: "bold" }}>
                {wallet?.walletAmount?.toLocaleString("fa")} ریال
              </span>
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              تاریخ انقضا:{" "}
              <span style={{ fontWeight: "bold" }}>
                {wallet?.expirationDatePersian}
              </span>
            </Typography>

            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              تاریخ آخرین تراکنش:{" "}
              <span style={{ fontWeight: "bold" }}>
                {wallet?.lastTransactionDatePersian}
              </span>
            </Typography>
            <Typography sx={{ width: "20%" }}></Typography>
            <Typography sx={{ width: "20%" }}></Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomerLoanCard;
